import { useContext } from "react";
import { ShellContext } from "../context";
import { ModuleInfo } from "../model";

/**
 * Returns the module the shell will redirect to when navigating to the root path ("/").
 */
export function useRootModule(): ModuleInfo | null {
  const { rootModule } = useContext(ShellContext);
  return rootModule;
}
